import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useSessionStore } from '@xjlv2/auth'
import App from './App.vue'
import './style.css'
import '@xjlv2/ui/styles/workspace-theme.css'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .catch((error) => console.warn('[saas-shell] Service Worker 注销失败', error))
}

if ('caches' in window) {
  window.caches.keys()
    .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
    .catch((error) => console.warn('[saas-shell] Cache Storage 清理失败', error))
}

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// 流量采集默认关闭：仅在 VITE_TRAFFIC_ENABLED==='true' 时动态装配，
// 未设置时 traffic-shell 模块零执行路径（见 README「流量采集」）。
if (import.meta.env.VITE_TRAFFIC_ENABLED === 'true') {
  void import('./traffic/traffic-shell').then(({ setupShellTraffic }) => {
    const session = useSessionStore(pinia)
    setupShellTraffic({
      tenantId: () => session.tenantId,
      createApiClient: () => session.createApiClient()
    })
  }).catch((error) => console.error('[saas-shell] 流量采集模块加载失败', error))
}

// 错误上报默认关闭：仅在 VITE_CRASH_ENABLED==='true' 时动态装配（off 零副作用，
// 同 traffic 先例），装配点挂 window 双钩 + app.config.errorHandler（见 README「错误上报」）。
if (import.meta.env.VITE_CRASH_ENABLED === 'true') {
  void import('./crash/crash-shell').then(({ setupShellCrash }) => {
    const session = useSessionStore(pinia)
    setupShellCrash(app, { createApiClient: () => session.createApiClient() })
  }).catch((error) => console.error('[saas-shell] 错误上报模块加载失败', error))
}

app.mount('#app')
